import React from 'react';
import { Link } from 'react-router-dom';

const SUPPORT_EMAIL = 'support@leadmarka.co.zw';
const OPERATOR_NAME = 'YURI DIGITAL (PRIVATE) LIMITED';
const OPERATOR_DETAILS = 'Entity No. 57023A0292025, 7 Livingstone Avenue, The Legacy building, Harare, Zimbabwe';

const Terms = () => {
  return (
    <div className="min-h-screen bg-gray-50 px-4 py-8">
      <div className="max-w-2xl mx-auto">
        <div className="mb-6 flex items-center justify-between">
          <Link
            to="/"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium"
          >
            Back to app
          </Link>
          <Link
            to="/privacy"
            className="text-sm text-gray-500 hover:text-gray-700"
          >
            Privacy Policy
          </Link>
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-2">Terms of Service</h1>
        <p className="text-sm text-gray-500 mb-6">Effective date: September 21, 2026</p>

        <div className="space-y-4 text-sm text-gray-700">
          <p>
            These Terms of Service ("Terms") govern your use of LeadMarka, a product operated by {OPERATOR_NAME}, a
            company registered in Zimbabwe ("Yuri Digital", "we", "us"). By creating an account or using the service,
            you agree to these Terms.
          </p>

          <h2 className="text-lg font-semibold text-gray-900">1. Accounts</h2>
          <p>
            You must provide accurate information and keep your login credentials secure. You are responsible for all
            activity on your account. If you believe your account is compromised, contact us immediately.
          </p>

          <h2 className="text-lg font-semibold text-gray-900">2. Use of the Service</h2>
          <p>
            You agree not to misuse the service, interfere with its operation, attempt unauthorized access, or use it to
            send unlawful, harmful, or deceptive content.
          </p>
          <p>
            If you connect WhatsApp Business, you must have permission to use the contacts and content you provide. You
            must comply with applicable law and the WhatsApp Business Messaging and Commerce Policies. You may not use
            LeadMarka to send spam or market prohibited goods or services.
          </p>

          <h2 className="text-lg font-semibold text-gray-900">3. Your Data</h2>
          <p>
            You own the data you enter into LeadMarka, including leads, notes, and follow-ups. You grant us a limited
            license to host, process, transmit to our service providers, and display your data solely to provide the
            service. If you enable AI features, this includes processing conversation text, voice notes, CRM context,
            approved business knowledge, and embeddings to transcribe audio, extract CRM details, retrieve relevant
            information, and prepare replies.
          </p>

          <h2 className="text-lg font-semibold text-gray-900">4. Third-Party Services</h2>
          <p>
            We rely on third-party providers, including Meta and WhatsApp for connected WhatsApp features, Supabase for
            data storage, OpenAI for optional text, audio, CRM, knowledge-retrieval, and embedding processing, Resend for
            email delivery, Sentry for error monitoring, and payment providers for paid plans. Your use of those features
            is also subject to the relevant provider terms and policies.
          </p>

          <h2 className="text-lg font-semibold text-gray-900">5. AI Features</h2>
          <p>
            AI output can be incomplete or wrong and must be reviewed for your use case. Workspace owners choose whether
            available AI replies are drafts for staff review or automatic replies. Starting a new AI context does not
            delete message history or other stored records. You remain responsible for messages sent from your workspace
            and for decisions made using extracted CRM data or AI output.
          </p>

          <h2 className="text-lg font-semibold text-gray-900">6. Availability and Changes</h2>
          <p>
            We aim for high availability but do not guarantee uninterrupted service. We may update or change features
            over time. We will try to give notice of material changes when practical.
          </p>

          <h2 className="text-lg font-semibold text-gray-900">7. Termination</h2>
          <p>
            You may stop using the service at any time. We may suspend or terminate accounts that violate these Terms or
            pose a security risk. Account deletion instructions are available in our{' '}
            <Link to="/privacy#data-deletion" className="text-primary-600 hover:text-primary-700 font-medium">
              Privacy Policy
            </Link>.
          </p>

          <h2 className="text-lg font-semibold text-gray-900">8. Disclaimers</h2>
          <p>
            LeadMarka is provided "as is" and "as available". We do not warrant that the service will be error-free or
            meet all of your requirements.
          </p>

          <h2 className="text-lg font-semibold text-gray-900">9. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, Yuri Digital will not be liable for indirect, incidental, special,
            consequential, or punitive damages, or for loss of profits or data arising from your use of the service.
          </p>

          <h2 className="text-lg font-semibold text-gray-900">10. Governing Law</h2>
          <p>
            These Terms are governed by the laws of Zimbabwe, without regard to conflict of law principles.
          </p>

          <h2 className="text-lg font-semibold text-gray-900">11. Contact</h2>
          <p>
            The service operator is {OPERATOR_NAME}, {OPERATOR_DETAILS}. Questions about these Terms? Email us at{' '}
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              className="text-primary-600 hover:text-primary-700 font-medium"
            >
              {SUPPORT_EMAIL}
            </a>{' '}
            or visit{' '}
            <a
              href="https://yuridigital.co.zw/"
              className="text-primary-600 hover:text-primary-700 font-medium"
              rel="noopener noreferrer"
            >
              yuridigital.co.zw
            </a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
